export const filterToDOMAttributes = attrs => Object.fromEntries(Object.entries(attrs).filter(([key]) => !key.includes('$') && !key.match(/^[0-9]/)));